namespace TabAurous.Purchase {
    export namespace MaterialInItemsService {
        export const baseUrl = 'Purchase/MaterialInItems';

        export declare function Create(request: Serenity.SaveRequest<MaterialInItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<MaterialInItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<MaterialInItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<MaterialInItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<MaterialInItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/MaterialInItems/Create",
            Update = "Purchase/MaterialInItems/Update",
            Delete = "Purchase/MaterialInItems/Delete",
            Retrieve = "Purchase/MaterialInItems/Retrieve",
            List = "Purchase/MaterialInItems/List",
            CustomList = "Purchase/MaterialInItems/CustomList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList'
        ].forEach(x => {
            (<any>MaterialInItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
